// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vcc {
  display: flex;
  flex-direction: column;
  gap: 18px;
  color: var(--color-text-primary, #1e1e1e);
  font-family: inherit;
}

.vcc__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.vcc__header h3 {
  margin: 0 0 4px;
  font-size: 1.15rem;
  font-weight: 700;
}

.vcc__header p {
  margin: 0;
  font-size: 0.85rem;
  color: var(--color-text-secondary, #838383);
}

.vcc__close {
  border: none;
  background: transparent;
  font-size: 1.6rem;
  line-height: 1;
  cursor: pointer;
  color: var(--color-text-secondary, #838383);
  padding: 0 4px;
}

.vcc__empty {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
  text-align: center;
  padding: 48px 24px;
  color: var(--color-text-secondary, #838383);
}

.vcc__empty p {
  margin: 0;
  font-weight: 600;
  color: var(--color-text-primary, #1e1e1e);
}

.vcc__empty span {
  font-size: 0.85rem;
  max-width: 340px;
}

/* --- consent --- */
.vcc__consent {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 14px;
  border-radius: 10px;
  font-size: 0.83rem;
  border: 1px solid transparent;
}

.vcc__consent strong {
  font-size: 0.85rem;
}

.vcc__consent--ok {
  background: #e9f7ef;
  border-color: #b7e4c7;
  color: #1b6b3a;
}

.vcc__consent--blocked {
  background: #fdecea;
  border-color: #f5c2c0;
  color: #9b1c1c;
}

/* --- layout --- */
.vcc__body {
  display: grid;
  grid-template-columns: minmax(240px, 300px) 1fr;
  gap: 24px;
  align-items: start;
}

@media (max-width: 820px) {
  .vcc__body {
    grid-template-columns: 1fr;
  }
}

.vcc__stage {
  display: flex;
  justify-content: center;
}

.vcc__phone {
  position: relative;
  width: 100%;
  max-width: 300px;
  aspect-ratio: 9 / 16;
  border-radius: 18px;
  overflow: hidden;
  background: #000;
  box-shadow: 0 18px 44px rgba(0, 0, 0, 0.22);
}

.vcc__video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.vcc__rendering {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: rgba(0, 0, 0, 0.62);
  color: #fff;
  font-size: 0.88rem;
  font-weight: 600;
}

.vcc__spinner {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.25);
  border-top-color: #fff;
  animation: vcc-spin 0.9s linear infinite;
}

@keyframes vcc-spin {
  to {
    transform: rotate(360deg);
  }
}

/* --- panel --- */
.vcc__panel {
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0;
}

.vcc__panel section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.vcc__panel h4 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-text-secondary, #838383);
}

.vcc__candidates {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.vcc__candidate {
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-start;
  padding: 9px 13px;
  border-radius: 10px;
  border: 1.5px solid #e2e5e9;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}

.vcc__candidate:hover:not(:disabled) {
  border-color: var(--color-primary, #0877bc);
}

.vcc__candidate.is-selected {
  border-color: var(--color-primary, #0877bc);
  background: color-mix(in srgb, var(--color-primary, #0877bc) 8%, #fff);
}

.vcc__candidate:disabled {
  opacity: 0.55;
  cursor: default;
}

.vcc__candidate strong {
  font-size: 0.9rem;
}

.vcc__candidate span {
  font-size: 0.74rem;
  color: var(--color-text-secondary, #838383);
  font-variant-numeric: tabular-nums;
}

.vcc__primary,
.vcc__secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 11px 20px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 0.88rem;
  cursor: pointer;
  border: none;
  text-decoration: none;
  transition: opacity 0.15s;
}

.vcc__primary {
  background: var(--color-primary, #0877bc);
  color: #fff;
}

.vcc__secondary {
  background: #eef1f4;
  color: var(--color-text-primary, #1e1e1e);
}

.vcc__primary:disabled,
.vcc__secondary:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.vcc__link {
  border: none;
  background: none;
  padding: 0;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: var(--color-primary, #0877bc);
  cursor: pointer;
  text-transform: none;
}

.vcc__caption {
  width: 100%;
  border: 1.5px solid #e2e5e9;
  border-radius: 10px;
  padding: 11px 13px;
  font: inherit;
  font-size: 0.86rem;
  line-height: 1.5;
  resize: vertical;
}

.vcc__caption:focus {
  outline: none;
  border-color: var(--color-primary, #0877bc);
}

.vcc__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.vcc__hint {
  margin: 0;
  font-size: 0.76rem;
  color: var(--color-text-secondary, #838383);
  line-height: 1.45;
}

.vcc__accounts {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.vcc__account {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 11px;
  border-radius: 10px;
  border: 1.5px solid #e2e5e9;
  cursor: pointer;
}

.vcc__account img {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
}

.vcc__account span {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.vcc__account strong {
  font-size: 0.85rem;
}

.vcc__account em {
  font-style: normal;
  font-size: 0.73rem;
  color: var(--color-text-secondary, #838383);
}

.vcc__badge {
  margin-left: auto;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #9b1c1c;
  background: #fdecea;
  padding: 3px 8px;
  border-radius: 999px;
}

.vcc__result p {
  margin: 0 0 4px;
  font-size: 0.83rem;
}

.vcc__error {
  color: #9b1c1c;
  font-size: 0.83rem;
  line-height: 1.45;
}
`, "",{"version":3,"sources":["webpack://./src/components/social/ViralClipComposer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;EAC3C,sEAAsE;AACxE;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,oCAAoC;EACpC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":[".vcc {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  color: var(--color-text-primary, #1e1e1e);\n  font-family: inherit;\n}\n\n.vcc__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.vcc__header h3 {\n  margin: 0 0 4px;\n  font-size: 1.15rem;\n  font-weight: 700;\n}\n\n.vcc__header p {\n  margin: 0;\n  font-size: 0.85rem;\n  color: var(--color-text-secondary, #838383);\n}\n\n.vcc__close {\n  border: none;\n  background: transparent;\n  font-size: 1.6rem;\n  line-height: 1;\n  cursor: pointer;\n  color: var(--color-text-secondary, #838383);\n  padding: 0 4px;\n}\n\n.vcc__empty {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  align-items: center;\n  text-align: center;\n  padding: 48px 24px;\n  color: var(--color-text-secondary, #838383);\n}\n\n.vcc__empty p {\n  margin: 0;\n  font-weight: 600;\n  color: var(--color-text-primary, #1e1e1e);\n}\n\n.vcc__empty span {\n  font-size: 0.85rem;\n  max-width: 340px;\n}\n\n/* --- consent --- */\n.vcc__consent {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 10px 14px;\n  border-radius: 10px;\n  font-size: 0.83rem;\n  border: 1px solid transparent;\n}\n\n.vcc__consent strong {\n  font-size: 0.85rem;\n}\n\n.vcc__consent--ok {\n  background: #e9f7ef;\n  border-color: #b7e4c7;\n  color: #1b6b3a;\n}\n\n.vcc__consent--blocked {\n  background: #fdecea;\n  border-color: #f5c2c0;\n  color: #9b1c1c;\n}\n\n/* --- layout --- */\n.vcc__body {\n  display: grid;\n  grid-template-columns: minmax(240px, 300px) 1fr;\n  gap: 24px;\n  align-items: start;\n}\n\n@media (max-width: 820px) {\n  .vcc__body {\n    grid-template-columns: 1fr;\n  }\n}\n\n.vcc__stage {\n  display: flex;\n  justify-content: center;\n}\n\n.vcc__phone {\n  position: relative;\n  width: 100%;\n  max-width: 300px;\n  aspect-ratio: 9 / 16;\n  border-radius: 18px;\n  overflow: hidden;\n  background: #000;\n  box-shadow: 0 18px 44px rgba(0, 0, 0, 0.22);\n}\n\n.vcc__video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.vcc__rendering {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  background: rgba(0, 0, 0, 0.62);\n  color: #fff;\n  font-size: 0.88rem;\n  font-weight: 600;\n}\n\n.vcc__spinner {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 3px solid rgba(255, 255, 255, 0.25);\n  border-top-color: #fff;\n  animation: vcc-spin 0.9s linear infinite;\n}\n\n@keyframes vcc-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* --- panel --- */\n.vcc__panel {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  min-width: 0;\n}\n\n.vcc__panel section {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.vcc__panel h4 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--color-text-secondary, #838383);\n}\n\n.vcc__candidates {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.vcc__candidate {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  align-items: flex-start;\n  padding: 9px 13px;\n  border-radius: 10px;\n  border: 1.5px solid #e2e5e9;\n  background: #fff;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.vcc__candidate:hover:not(:disabled) {\n  border-color: var(--color-primary, #0877bc);\n}\n\n.vcc__candidate.is-selected {\n  border-color: var(--color-primary, #0877bc);\n  background: color-mix(in srgb, var(--color-primary, #0877bc) 8%, #fff);\n}\n\n.vcc__candidate:disabled {\n  opacity: 0.55;\n  cursor: default;\n}\n\n.vcc__candidate strong {\n  font-size: 0.9rem;\n}\n\n.vcc__candidate span {\n  font-size: 0.74rem;\n  color: var(--color-text-secondary, #838383);\n  font-variant-numeric: tabular-nums;\n}\n\n.vcc__primary,\n.vcc__secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 11px 20px;\n  border-radius: 999px;\n  font-weight: 700;\n  font-size: 0.88rem;\n  cursor: pointer;\n  border: none;\n  text-decoration: none;\n  transition: opacity 0.15s;\n}\n\n.vcc__primary {\n  background: var(--color-primary, #0877bc);\n  color: #fff;\n}\n\n.vcc__secondary {\n  background: #eef1f4;\n  color: var(--color-text-primary, #1e1e1e);\n}\n\n.vcc__primary:disabled,\n.vcc__secondary:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.vcc__link {\n  border: none;\n  background: none;\n  padding: 0;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  color: var(--color-primary, #0877bc);\n  cursor: pointer;\n  text-transform: none;\n}\n\n.vcc__caption {\n  width: 100%;\n  border: 1.5px solid #e2e5e9;\n  border-radius: 10px;\n  padding: 11px 13px;\n  font: inherit;\n  font-size: 0.86rem;\n  line-height: 1.5;\n  resize: vertical;\n}\n\n.vcc__caption:focus {\n  outline: none;\n  border-color: var(--color-primary, #0877bc);\n}\n\n.vcc__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.vcc__hint {\n  margin: 0;\n  font-size: 0.76rem;\n  color: var(--color-text-secondary, #838383);\n  line-height: 1.45;\n}\n\n.vcc__accounts {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.vcc__account {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 11px;\n  border-radius: 10px;\n  border: 1.5px solid #e2e5e9;\n  cursor: pointer;\n}\n\n.vcc__account img {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.vcc__account span {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.vcc__account strong {\n  font-size: 0.85rem;\n}\n\n.vcc__account em {\n  font-style: normal;\n  font-size: 0.73rem;\n  color: var(--color-text-secondary, #838383);\n}\n\n.vcc__badge {\n  margin-left: auto;\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #9b1c1c;\n  background: #fdecea;\n  padding: 3px 8px;\n  border-radius: 999px;\n}\n\n.vcc__result p {\n  margin: 0 0 4px;\n  font-size: 0.83rem;\n}\n\n.vcc__error {\n  color: #9b1c1c;\n  font-size: 0.83rem;\n  line-height: 1.45;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
